import { EntityAttribute } from "shared/api/api";
import client from "shared/api/axios";
import { createURL } from "shared/api/utils";

export interface SingleResourceAttributesResponse {
  attributes: EntityAttribute[];
  resource: string;
  endpoint: string;
  tableName: string;
  type: "dynamic" | "static";
}

export type AllAttributesResponse = Partial<
  Record<string, SingleResourceAttributesResponse | undefined>
>;

export const listAttributesRequestURI = (): string =>
  client.getUri({
    method: "get",
    url: createURL(["internal", "attributes"]),
  });
